import { useEffect } from 'react';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import AboutHero from '../components/about/AboutHero';
import OurStory from '../components/about/OurStory';
import MeetTheTeam from '../components/about/MeetTheTeam';
import styles from './AboutPage.module.css';

// Public "About us" page. Reuses the marketing nav/footer and owns its own scroll
// container (the global stylesheet sets `body { overflow: hidden }` for the app shell).
export default function AboutPage() {
  // Land at the top when arriving from another route.
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <AboutHero />
        <OurStory />
        <MeetTheTeam />
      </main>
      <LandingFooter />
    </div>
  );
}
